const koalaInputs = document.querySelectorAll('.koala-deal__tier__input');

function addedPriceToBTN (price) {
    const addToCartSpan = document.querySelector('.add-to-cart-btn span[x-text="addToCartText"]');
    if (!addToCartSpan) return;

    let oldPrice = addToCartSpan.parentElement.querySelector('.js-added-price');
    if (oldPrice) oldPrice.remove();

    const priceEl = document.createElement('span');
    priceEl.className = 'js-added-price';
    priceEl.textContent = ` - ${price}`;

    addToCartSpan.parentElement.appendChild(priceEl);
}

function updateCheckedPrice() {
  const checkedInput = document.querySelector('.koala-deal__tier__input:checked');
  if (!checkedInput) return;

  const checkedLabel = checkedInput.nextElementSibling;


  const checkedInputPrice = checkedLabel
    .querySelector('.koala-deal__tier__price')
    .textContent.trim();

  addedPriceToBTN(checkedInputPrice);  

  console.log('checkedInputPrice:', checkedInputPrice);
}


updateCheckedPrice();

koalaInputs.forEach(input => {
  input.addEventListener('change', updateCheckedPrice);
});
